const BASE = "/api/v1";

async function request<T = any>(
  method: string,
  url: string,
  data?: any
): Promise<T> {
  const token = localStorage.getItem("dataset_token");
  const headers: Record<string, string> = {};

  if (token) headers["Authorization"] = `Bearer ${token}`;

  const opts: RequestInit = { method, headers };

  if (data && !(data instanceof FormData)) {
    headers["Content-Type"] = "application/json";
    opts.body = JSON.stringify(data);
  } else if (data instanceof FormData) {
    opts.body = data;
  }

  const res = await fetch(`${BASE}${url}`, opts);

  if (res.status === 401 || res.status === 403) {
    localStorage.removeItem("dataset_token");
    window.location.href = "/login";
    throw new Error("Нэвтрэх шаардлагатай");
  }

  const json = await res.json();

  if (!res.ok || !json.success) {
    throw new Error(json.message || "Алдаа гарлаа");
  }

  return json;
}

function qs(params: Record<string, any>): string {
  const filtered = Object.entries(params).filter(
    ([, v]) => v !== undefined && v !== null && v !== ""
  );
  if (filtered.length === 0) return "";
  return "?" + new URLSearchParams(filtered.map(([k, v]) => [k, String(v)])).toString();
}

export const api = {
  auth: {
    login: (data: { username: string; password: string }) =>
      request("POST", "/auth/login", data),
    me: () => request("GET", "/auth/me"),
  },
  general: {
    init: () => request("GET", "/general/init"),
  },
  image: {
    list: (params: any) => request("GET", `/image${qs(params)}`),
    upload: (type: string, file: File) => {
      const fd = new FormData();
      fd.append("file", file);
      return request("POST", `/image/upload/${type}`, fd);
    },
    detect: (data: any) => request("POST", "/image/detect", data),
    distribute: (data: any) => request("POST", "/image/distribute", data),
  },
  project: {
    list: (params: any) => request("GET", `/project${qs(params)}`),
    detail: (id: string) => request("GET", `/project/${id}`),
    create: (data: any) => request("POST", "/project", data),
    update: (id: string, data: any) => request("PUT", `/project/${id}`, data),
    remove: (id: string) => request("DELETE", `/project/${id}`),
    select: () => request("GET", "/project/select"),
    change: (id: string) => request("POST", `/project/${id}/change`),
  },
  dataset: {
    list: (params: any) => request("GET", `/dataset${qs(params)}`),
    create: (data: any) => request("POST", "/dataset", data),
  },
  audit: {
    list: (params: any) => request("GET", `/audit${qs(params)}`),
    create: (data: any) => request("POST", "/audit", data),
    detail: (id: string, params: any) => request("GET", `/audit/${id}${qs(params)}`),
    names: (id: string) => request("GET", `/audit/${id}/names`),
    review: (id: string, status: string) =>
      request("PUT", `/audit/image/${id}/${status}`),
  },
  user: {
    list: (params: any) => request("GET", `/user${qs(params)}`),
    detail: (id: string) => request("GET", `/user/${id}`),
    create: (data: any) => request("POST", "/user", data),
    update: (id: string, data: any) => request("PUT", `/user/${id}`, data),
    remove: (id: string) => request("DELETE", `/user/${id}`),
  },
  name: {
    list: () => request("GET", "/name"),
    create: (data: any) => request("POST", "/name", data),
    remove: (id: string) => request("DELETE", `/name/${id}`),
    bulk: (names: string[]) => request("POST", "/name/bulk", { names }),
  },
  apiKey: {
    list: () => request("GET", "/api-key"),
    create: (data: any) => request("POST", "/api-key", data),
    remove: (id: string) => request("DELETE", `/api-key/${id}`),
    toggle: (id: string) => request("PUT", `/api-key/${id}/toggle`),
  },
  imageType: {
    list: () => request("GET", "/image-type"),
    create: (data: any) => request("POST", "/image-type", data),
    remove: (id: string) => request("DELETE", `/image-type/${id}`),
  },
  dashboard: {
    stats: () => request("GET", "/dashboard/stats"),
    detect: () => request("GET", "/dashboard/detect"),
    edited: () => request("GET", "/dashboard/edited"),
  },
};
